import { fixMarkdownLineBreaks } from '../../../../assistant/utils/markdownUtils';

// Utility function to parse agent messages with embedded widgets
export const parseAgentMessage = (rawMessage) => {
    let message = rawMessage;
    let widget = null;
    let dcfId = null;
    let suggestedActions = null;

    // Extract widget if present
    const widgetMatch = message.match(/\[WIDGET:([\w_]+)\](.*?)\[\/WIDGET\]/s);
    if (widgetMatch) {
        try {
            widget = {
                type: widgetMatch[1],
                data: JSON.parse(widgetMatch[2])
            };
            // Remove widget from message content
            message = message.replace(/\[WIDGET:[\w_]+\].*?\[\/WIDGET\]/s, '').trim();
        } catch (e) {
            console.error('Failed to parse widget data:', e);
        }
    }

    // Extract DCF ID
    const dcfMatch = message.match(/DCF_ID:(\S+)/);
    if (dcfMatch) {
        dcfId = dcfMatch[1];
        message = message.replace(/DCF_ID:\S+\.?/, '').trim();
    }

    // Extract suggested actions
    const actionsMatch = message.match(/Suggested actions: (.+)/);
    if (actionsMatch) {
        suggestedActions = actionsMatch[1].split(', ')
            .map(s => s.trim())
            .filter(s => s && !/^update$/i.test(s) && !/^complete$/i.test(s));
        message = message.replace(/\nSuggested actions: .+/, '').trim();
    }

    return {
        cleanMessage: fixMarkdownLineBreaks(message),
        widget,
        dcfId,
        suggestedActions
    };
};